// The document statuses the billing dashboard reacts to, as returned by the API. The
// server already applied the billable rule (a failed purchase is never a line), so the
// only status the UI branches on is the unsettled one — a pending price can still fail
// and take itself back out, which makes any total containing it provisional.
export const LEGAL_BILLING_STATUS_PENDING = "pending"

// Marking is destructive-ish in the sense that it feeds a real invoice, so the buttons
// say which direction they go rather than "toggle".
export const LEGAL_BILLING_MARK_LABEL = "Mark invoiced"
export const LEGAL_BILLING_UNMARK_LABEL = "Unmark"
